import React from 'react';
import { observer } from "mobx-react";
import { toJS } from 'mobx';
import { ShowableCart } from 'ReactApp/Ddd/Aggregates/ShowableCart';
import PaymentRadioListElementV1 from '../PaymentRadioListElementV1/PaymentRadioListElementV1';

type PaymentRadioListV1Props = {
    showableCart: ShowableCart,
    inputName: string
}

const PaymentRadioListV1 = observer((props: PaymentRadioListV1Props) => {

    return (
        <>
            <div className="input-radio-list-v1 input-radio-list-v1_payment-type">

                {props.showableCart.payments.map((payment, index) => {
                    return (
                        typeof payment.isActive === 'function'
                            ? payment.isActive()
                            : payment.isActive
                    ) && (
                        <PaymentRadioListElementV1 key={`prlev1-${index}`} {...{
                            showableCart: props.showableCart,
                            paymentInfo: payment,
                            inputName: props.inputName,
                        }} />
                    );
                })}

                <div 
                    className={
                        `invalid-feedback` + (
                            props.showableCart.order.paymentType === null ? ` show` : ``
                        )
                    }
                    >        
                </div>

            </div>
        </>
    );

})

export default PaymentRadioListV1;